module.exports = __webpack_public_path__ + "static/media/getContact.88eb1bc2.jpg";